var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.545 5.998"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31475",
    d: "M5.274 5.999a.648.648 0 00.256-.053.62.62 0 00.217-.16l4.612-4.713a.6.6 0 00.186-.44.621.621 0 00-.084-.322.634.634 0 00-.226-.225.617.617 0 00-.321-.084.639.639 0 00-.454.188l-4.5 4.6h.622l-4.5-4.6A.623.623 0 00.633.002a.617.617 0 00-.324.084.634.634 0 00-.226.226.621.621 0 00-.084.322.587.587 0 00.049.241.668.668 0 00.137.2l4.608 4.717a.67.67 0 00.481.207z",
    fill: "inherit"
  })));
}

export default SvgExpand;